import { Component, ViewChild, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { OBPPLoginService } from 'src/app/services/login-page/login-page.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OBPPModalDialogComponent } from '../../error-component/modal-dialog/modal-dialog.component';
import { OBPPQuickPayService } from 'src/app/services/quick-pay/quick-pay.service';
import { QuickPaySecurityAudit } from 'src/app/models/new-user-registration.model';
import { Router } from '@angular/router';
import { DataSharingService } from 'src/app/services/login-page/data-sharing.service';
import { WafCaptchaModalComponent } from "../../waf/waf-captcha-modal.component";
import { CaptchaLoaderService } from 'src/app/services/captcha-loader.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'obpp-quick-pay-anonymous',
  templateUrl: './obpp-quick-pay.component.html',
  styleUrls: ['./obpp-quick-pay.component.scss'],
})
export class OBPPQuickPayAnonymousComponent implements OnInit, OnDestroy {
  content?: string;
  username: string = '';
  pwd: string = '';
  QuickPayForm: FormGroup;
  isDuplicatePay = false;
  isWafCaptchaSdkLoaded = false;
  secAuditData?: QuickPaySecurityAudit | any;

  @ViewChild(WafCaptchaModalComponent) captcha!: WafCaptchaModalComponent;

  private formValueChangeSubscription?: Subscription;

  constructor(
    private obppAuthService: OBPPLoginService,
    private obppQuickPayService: OBPPQuickPayService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private route: Router,
    private dataSharingService: DataSharingService,
    private captchaLoaderService: CaptchaLoaderService,
    private cdr: ChangeDetectorRef
  ) {
    this.QuickPayForm = this.fb.group({
      accountNumber: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(12)]],
      invoiceNumber: ['', [Validators.required, Validators.maxLength(15)]],
      postalCode: ['', [Validators.required, Validators.maxLength(11)]],
    });
  }

  ngOnInit() {
    this.formValueChangeSubscription = this.QuickPayForm.valueChanges.subscribe(async () => {
      if (this.formValueChangeSubscription) {
        this.isWafCaptchaSdkLoaded = await this.loadCaptchaSdk();
        this.formValueChangeSubscription.unsubscribe();
        this.formValueChangeSubscription = undefined;
      }
    });
  }

  ngOnDestroy() {
    if (this.formValueChangeSubscription) {
      this.formValueChangeSubscription.unsubscribe();
    }
  }

  validateFields() {
    this.QuickPayForm.get('accountNumber')?.markAsDirty();
    this.QuickPayForm.get('invoiceNumber')?.markAsDirty();
    this.QuickPayForm.get('postalCode')?.markAsDirty();

    if (this.QuickPayForm.valid) {
      return true;
    }
    return false;
  }

  async onSubmit() {
    this.QuickPayForm.markAllAsTouched();
    if (this.QuickPayForm.invalid) return;
    const accountNumber = this.QuickPayForm.get('accountNumber')?.value?.trim();
    const invoiceNumber = this.QuickPayForm.get('invoiceNumber')?.value?.replace(/ /g, '')?.trim();
    const postalCode = this.QuickPayForm.get('postalCode')?.value?.replace(/ /g, '')?.trim();
    await this.getQuickPayDataAll(accountNumber, invoiceNumber, postalCode);
  }


  openModal(
    title: string,
    errorMsg: string,
    firstButtonLabel: any,
    secondButtonLabel: any,
    modalType: string
  ) {
    const modalRef = this.modalService.open(OBPPModalDialogComponent);
    modalRef.componentInstance.my_modal_title = title;
    modalRef.componentInstance.my_modal_content = errorMsg;
    modalRef.componentInstance.firstButtonLabel = firstButtonLabel;
    modalRef.componentInstance.secondButtonLabel = secondButtonLabel;
    modalRef.componentInstance.modalType = modalType;
  }

  async getQuickPayDataAll(accountNumber: string, invoiceNumber: string, postalCode: string): Promise<void> {
    await this.captcha.show();
    this.dataSharingService.IsLoadingEnabled.next(true);
    const tit = 'QUICK_PAY_TEXT';
    const errMsg = 'QUICK_PAY_ERROR';

    try {
      this.obppQuickPayService.getAccountInfoByDetailsWithCaptcha(accountNumber, invoiceNumber, postalCode)
        .subscribe({
          next: (res) => {
            if (res.serviceResponse.type == 'success') {
              this.obppQuickPayService.quickPayData = res.serviceResponse;
              this.obppQuickPayService.selectedInvoice = invoiceNumber;
              this.dataSharingService.IsLoadingEnabled.next(false);
              this.route.navigateByUrl('/quickpay');
              this.dataSharingService.isRefreshRequired.next('quickpay');
            } else {
              this.dataSharingService.IsLoadingEnabled.next(false);
              this.openModal(tit, errMsg, 'OK', null, 'warning');
            }
          }
        });
    } catch (e: any) {
      console.debug('CAPTCHA not solved', e);
    }
  }

  async loadCaptchaSdk(): Promise<boolean> {
    try {
      await this.captchaLoaderService.load();
      return true;
    } catch (e) {
      console.error('Failed to load CAPTCHA SDK:', e);
      return false;
    }
  }

}
